import dayjs from "dayjs";
import React from "react";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const DateRange = ({
    onDateRangeChange,
    startDate,
    endDate,
    minDate,
    maxDate,
    dateFormat = 'YYYY-MM-DD',
    className = '',
    allowWeekends = false
}) => {
    // Helper function to parse date, handling string or Unix timestamp (both seconds and milliseconds)
    const parseDate = (date) => {
        if (typeof date === 'number') {
            // Check if the timestamp is in milliseconds or seconds
            return date.toString().length === 13 ? dayjs(date) : dayjs.unix(date);
        }
        return dayjs(date, dateFormat);
    };

    // Helper function to format the date
    const formatDate = (date) => {
        const parsedDate = parseDate(date);
        return parsedDate.isValid() ? parsedDate.format(dateFormat) : null;
    };

    // Format startDate, endDate, minDate, and maxDate
    const startFormatted = startDate ? formatDate(startDate) : null;
    const endFormatted = endDate ? formatDate(endDate) : null;
    const minFormatted = minDate ? formatDate(minDate) : null;
    const maxFormatted = maxDate ? formatDate(maxDate) : null;

    // Handle date range change
    const handleDateRangeChange = (dates, dateStrings) => {
        if (onDateRangeChange) {
            onDateRangeChange(dateStrings[0], dateStrings[1]);
        }
    };

    // Disable specific dates (weekends and dates outside min/max range)
    const disabledDate = (current) => {
        const isBeforeMinDate = minFormatted && current.isBefore(dayjs(minFormatted));
        const isAfterMaxDate = maxFormatted && current.isAfter(dayjs(maxFormatted));
        const isWeekend = current.day() === 0 || current.day() === 6;

        return isBeforeMinDate || isAfterMaxDate || (!allowWeekends && isWeekend);
    };

    return (
        <RangePicker
            size="small"
            className={`py-3 ${className}`}
            format={dateFormat}
            defaultValue={[startFormatted ? dayjs(startFormatted) : null, endFormatted ? dayjs(endFormatted) : null]}
            onChange={handleDateRangeChange}
            disabledDate={disabledDate}
        />
    );
};

export default DateRange;
